import React, { useEffect, useState } from "react";
import { FxValueInfo } from "./../../fxms/components/FxValueInfo";
import { FxmsData } from "./../../fxms/datas/FxData";
import { FxRenderer } from "../../fxms/datas/FxRenderer";


/**
 * 에너지 사용, 생산량 표시.
 * 개발자 : 김종훈.
 * 개발년월 : 2022.11.
 * @returns 
 */
export const FeEngValueInfo = (props) => {

  const { title, engId, type, sx } = props;
  const [eng, setEng] = useState({});
  const [value, setValue] = useState("-");
  const [subInfoList, setSubInfoList] = useState([]);

  useEffect(() => {
    if (engId) {
      const engList = FxmsData.getDatas("energy");
      if (engList) {
        for (const e of engList) {
          if (e.engId === engId) {
            setEng(e);
            if (type === 'cons') getConsDatas(e);
            else getProdDatas(e);
            break;
          }
        }
      }
    }
  }, [engId]);

  async function getConsDatas(eng) {
    const uri = "fems/select_eng_cons__today";
    const para = { engId: eng.engId };
    const res = await FxmsData.GET(uri, para);
    if (res.data.length > 0) {
      const subInfoList = [];
      let sum = 0;
      let fristData = res.data[0];
      let lastData = res.data[res.data.length - 1];
      for (let data of res.data) {
        sum += data.consAmt;
      }
      subInfoList.push(FxRenderer.renderHHMM(fristData.consDtm) + " ~ " + FxRenderer.renderHHMM(lastData.consDtm) + " 기준");
      subInfoList.push(Number(lastData.consAmt.toFixed(0)).toLocaleString() + "  " + FxRenderer.renderHHMM(lastData.consDtm) + " 기준");

      setValue(Number(sum.toFixed(0)).toLocaleString());
      setSubInfoList(subInfoList);
    } else {
      setValue("-");
      setSubInfoList([]);
    }
  }

  async function getProdDatas(eng) {
    const uri = "fems/select_eng_prod__sum_date";
    const para = { engId: eng.engId };
    const res = await FxmsData.GET(uri, para);
    if (res.data.length > 0) {
      const subInfoList = [];
      let fristData = res.data[0];
      let lastData = res.data[res.data.length - 1];
      subInfoList.push("전일실적 " + Number(lastData.prodAmt.toFixed(0)).toLocaleString() + " " + eng.engUnit + "/일");
      setValue(Number(fristData.prodAmt.toFixed(0)).toLocaleString());
      setSubInfoList(subInfoList);
    } else {
      setValue("-");
      setSubInfoList([]);
    }
  }


  // <FxValueInfo title={'전력 사용량'} value={kwh.toLocaleString()} unit={'kWh'} subInfoList={['00:00~15:00기준', '820kW 15:00기준']} />


  return <FxValueInfo title={title} value={value} unit={eng.engUnit + "/일"} subInfoList={subInfoList} sx={sx} />;
};
